import React from 'react';

const PageTitleUserInterface = () => {
    return (
        <div id="page-title">
            <div className="wrapper">
                <h1>Loversy user interface (UI)</h1>
            </div>
        </div>
    );
};

export default PageTitleUserInterface;
